export const constructPageName = (useSuffix: boolean, pageUrl: string, suffix: string) =>
  useSuffix ? `${pageUrl}/${suffix}` : pageUrl;

export const getMyAccountSubPageAsyncData = async (
  pageUrl: string,
  customShelterRedirectPath = '',
  disableRedirect = false,
) => {
  const { $api, $i18n } = useNuxtApp();
  const userStore = useUserStore();

  // On my-account pages, always (p)re-load the user to have up-to-date data
  await userStore.loadUser();

  const { isShelterAccount } = userStore.user || {};
  const pageName = constructPageName(isShelterAccount, pageUrl, MY_ACCOUNT_PAGES_URL_SUFFIX);

  // TODO: Later on, make this compatible with `route.meta.routeCmsPage` and `mainStore.loadRoutePage`.
  //  For now it should hopefully be fine to use `getPage` instead of `loadRoutePage` here, because my-account
  //  pages all use the default header/footer and not the flexible one. So theoretically not needed in the layout,
  //  it should just use the global ones and be happy about it.
  const { data, error } = await useAsyncData(pageName, () => $api.getPage(pageName));
  const page = unref(data);

  if (!page && isShelterAccount && !disableRedirect) {
    await navigateTo(customShelterRedirectPath || $i18n.t('url.account.index'));
  }

  return { page, error: unref(error) };
};
